import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { NOTIFICATION_SEARCH_START_LOADING, NOTIFICATION_SEARCH_END_LOADING, NOTIFICATION_SEARCH_LOADED, SET_NOTIFICATION_FILTER } from "../constants/NotificationConstants";
import { NOTIFICATION_START_LOADING, NOTIFICATION_END_LOADING, NOTIFICATION_LOADED } from "../constants/NotificationConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null
};

const NotificationReducer = (state = initialState, action) => {
    switch(action.type) {
        case NOTIFICATION_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case NOTIFICATION_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case NOTIFICATION_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_NOTIFICATION_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case NOTIFICATION_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case NOTIFICATION_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case NOTIFICATION_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default NotificationReducer;